import React, { useContext } from 'react';

import { UserContext } from '../../contexts';

const Badge = ({ when, type }) => {
    return when ? <span className={`badge ${type}`} title={type.toUpperCase()} /> : null;
}

const ListingBadges = ({ listing }) => {
    const { user } = useContext(UserContext);

    return (
        <div className="badges">
            <Badge when={listing.is_hot} type="hot" />
            <Badge when={listing.is_exclusive} type="exclusive" />
            <Badge when={listing.is_rare} type="rare" />
            <Badge when={listing.is_investment} type="investment" />

            {/* CORRECT use of `is_dao_admin` (= `is_admin && !is_merchant`).
                `internal_product` is a per-store ownership field (owned /
                consignment / owned-by-merchants) set on the store's own
                listings — see the ungated toggles in RCListingCard and
                useListingDetailsRow. The distinction here really is
                staff-vs-merchant: a marketplace merchant is always "owned by
                merchants", so the provenance badges are meaningless to them.
                No cross-tenant data is involved — a store admin only ever sees
                their own listings. Do NOT tighten to is_master_admin. */}
            {user?.is_dao_admin && (
              <>
                <Badge when={listing.internal_product === 'owned'} type="available" />
                <Badge when={listing.internal_product === 'no'} type="merchant" />
                <Badge when={listing.internal_product === 'to_be_procured'} type="procured" />
              </>
            )}
        </div>
    );
}

export default ListingBadges
